import BaseNormalizer from "./BaseNormalizer";

const discountsInKindNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "count",
  "product.id",
  "product.productVariantName",
  "product.images",
]);

export default discountsInKindNormalizer;
